//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { get, isEmpty as isEmptyResponse } from "lodash";
//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List books ----------------
export const handleListUserBooks = (userId) => async (dispatch) => {
    await dispatch(ActivityActions.listUserBooks());

    try {
        let booksByUser = {}
        const booksByUserRDS = await apis.get('userBooksRDS', `/userBooksByUser/${userId}`);
        const hasError = get(booksByUserRDS,"error",false)
        const isEmpty = isEmptyResponse(booksByUserRDS)
        if (!hasError&&!isEmpty) {
            booksByUser = booksByUserRDS
        }
        await dispatch(ActivityActions.listUserBooksSuccess(booksByUserRDS));
        // -----------------------------------modified api end ----------------------------//
        return booksByUser;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing user books',
                error,
                module: 'USER_BOOKS',
                operation: 'LIST_USER_BOOK'
            });
         }
        await dispatch(ActivityActions.listUserBooksFail(error));
    }
};
export const getUserBooksById = async (userId) => {
    try {
        const booksByUserRDS = await apis.get('userBooksRDS', `/userBooksByUser/${userId}`);
        return booksByUserRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing user books',
                error,
                module: 'USER_BOOKS',
                operation: 'LIST_USER_BOOK'
            });
        }
        return null;
    }
}
export const handleListUserBooksForDist = (userId) => async (dispatch) => {
    await dispatch(ActivityActions.listUserBooks());

    try {
        const booksByUserRDS = await apis.post('userBooksRDS', `/getBookForOrg`,{
            body:{
                userId
            }
        });
       if(booksByUserRDS&&booksByUserRDS.success){
          await dispatch(ActivityActions.listUserBooksSuccess(booksByUserRDS.data));
       }
        return booksByUserRDS;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing user books for dist',
                error,
                module: 'USER_BOOKS',
                operation: 'LIST_USER_BOOK_FEEDBACK_DATA'
            });
         }
        await dispatch(ActivityActions.listUserBooksFail(error));
    }
};

export const handleRemoveBooksFromClass = (data) => async (dispatch) => {
    try {
        await apis.post('userBooksRDS', `/removeUserBook`, {
            body: data
        });

    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'removing books from class',
                error,
                module: 'USER_BOOKS',
                operation: 'REMOVE_BOOK_FEEDBACK_CONTENT'
            });
         }
        console.log(error);
    }
}

